import { graphql } from '@eluve/graphql.tada';

export const updateTenantDetailsMutation = graphql(`
  mutation UpdateTenantDetails(
    $tenantId: uuid!
    $logoUrl: String
    $name: String
  ) {
    updateTenantsByPk(
      pkColumns: { id: $tenantId }
      _set: { logoUrl: $logoUrl, name: $name }
    ) {
      __typename
      id
      logoUrl
      name
    }
  }
`);

export const tenantDefaultUiLanguageFragment = graphql(`
  fragment TenantDefaultUiLanguage on DefaultTenantUserSettings @_unmask {
    __typename
    tenantId
    uiLanguage
    nullUiLanguageUserCount
  }
`);

export const getTenantDefaultUiLanguageQuery = graphql(
  `
    query getTenantDefaultUiLanguage($tenantId: uuid!) {
      defaultTenantUserSettingsByPk(tenantId: $tenantId) {
        ...TenantDefaultUiLanguage
      }
    }
  `,
  [tenantDefaultUiLanguageFragment],
);

export const setTenantDefaultUiLanguageMutation = graphql(
  `
    mutation setTenantDefaultUiLanguage(
      $tenantId: uuid!
      $uiLanguage: String!
    ) {
      updateDefaultTenantUserSettingsByPk(
        pkColumns: { tenantId: $tenantId }
        _set: { uiLanguage: $uiLanguage }
      ) {
        ...TenantDefaultUiLanguage
      }
    }
  `,
  [tenantDefaultUiLanguageFragment],
);
